<app-cerrix-tree-item-picker
    [name]="name"
    [label]="label"
    [infoText]="infoText"
    [placeholder]="placeholder"
    [dialogTitle]="dialogTitle"
    [iconPrefix]="iconPrefix"
    [defaultIcon]="defaultIcon"
    [items]="items"
    [multiselect]="false"
    [selectedValue]="selectedValue ? [selectedValue] : []"
    (valueChanged)="onValueChanged($event)"
></app-cerrix-tree-item-picker>
